import { render, staticRenderFns } from "./gcr.vue?vue&type=template&id=7b617fe0&scoped=true"
import script from "./gcr.vue?vue&type=script&lang=js"
export * from "./gcr.vue?vue&type=script&lang=js"
import style0 from "./gcr.vue?vue&type=style&index=0&id=7b617fe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b617fe0",
  null
  
)

export default component.exports